<template>
  <div class="billboardContent">
    <div class="page-item">
            <div class="content">
              <div class="title">
                    {{billboardTitle}}榜单
                </div>
                <div class="tabnav">         
                    <ul v-if="!isShowMoreBrand">
                        <li :class="(brandMenuIndex==0?'on':'')"  @click="brandMenu(0)">
                            热门推荐
                        </li>
                        <li :class="(brandMenuIndex==item.value?'on':'')" v-for="(item,i) in showBrandList" :key="'brand_'+i" @click="brandMenu(item.value)">
                            {{item.name}}
                        </li>                        
                    </ul>
                    <a v-if="!isShowMoreBrand" class="showmore" @click="setBrandShow(true)">展开<i class="icon icon-list" ></i></a>
                    <ul v-if="isShowMoreBrand" style="flex-wrap:wrap">
                        <li :class="(brandMenuIndex==0?'on':'')"  @click="brandMenu(0)">
                            热门推荐
                        </li>
                        <li :class="(brandMenuIndex==item.value?'on':'')" v-for="(item,i) in brandList" :key="'brand_'+i" @click="brandMenu(item.value)">
                            {{item.name}}
                        </li>                        
                    </ul>
                    <a v-if="isShowMoreBrand" class="showmore" @click="setBrandShow(false)">收缩<i class="icon icon-list1"></i></a>
                </div>          
                <div class="tabcontent" v-loading="loading" element-loading-text="加载中...">
                    <ul>
                        <li v-for="(item,i) in goods" :key="i">
                                <div class="productIamge">
                                  <img :src="item.defaultImage" @click="toDetail(item.id)"/>
                                  <img class="productIcon" v-for="(labelItem,labelIndex) in item.labels" v-if="labelIndex<1&&labelItem.labelIcon" :key="labelIndex" :src="labelItem.labelIcon" />
                                </div>
                                <div class="productname">
                                    {{item.name}}
                                </div>
                                <div class="productprice">
                                    <span class="price">
                                      ￥{{item.settlementPrice}}
                                      <span class="scribe" v-if="item.settlementPrice<item.sellPrice">
                                        ￥{{item.sellPrice}}
                                    </span>
                                    </span>
                                   
                                    <span class="sales">
                                        成交{{item.sales}}件
                                     </span>
                                </div>                          
                            <div class="operationBtn">
                              <a  @click="toDetail(item.id)"><y-button text="查看详情"></y-button></a>                      
                              <y-button text="加入购物车"
                                @btnClick="showModal(item)"
                                classStyle="main-btn"
                              ></y-button>
                            </div>
                        </li>                       
                    </ul>                    
                </div>
                <el-pagination
                      v-if="!noResult&&!error"
                      @current-change="handleCurrentChange"
                      :page-size="pageSize"
                      @size-change="handleSizeChange"
                      :current-page.sync="currentPage3"
                      layout="prev, pager, next, jumper"
                      :total="goodsTotal">
                    </el-pagination>
            </div>
          </div>        
        <selectSpec ref="selectSpec"></selectSpec>
  </div>
</template>
<style>
@import '../../styles/billboard.css';
</style>
<script>
  import api from '@/api'
  import mallGoods from '@/components/mallGoods'
  import YButton from '@/components/yButton'
  import YShelf from '@/components/shelf' 
  import SelectSpec from './components/SelectSpec' 
  import {mapGetters, mapActions,mapMutations} from 'vuex'
  export default {
    data () {
      return {
        isShowMoreBrand:false,
        brandMenuIndex:0,
        showSpecModal:false,
        billboardTitle:'',
        error: false,
        loading: true,
        searching: true,
        sortType: null,
        sort: '',
        currentPage: 1,
        pageSize: 50,
        total: 0,
        key: '',
        brandList:[],
        showBrandList:[],
        brandId:0,
        keyType:0,
        sorting:'',
        sortAsc:false,
        currentPage3:1,
        productDetail:{}
      }
    },
    methods: {
      fetchData() {
        
      },
      showModal(item){      
        this.$refs['selectSpec'].showSelect(item)    
       },
       addSpecCart(id, price, name, img){
        let specId= this.checkAttr()
         if(!specId){
           return
         }
        let specName = ''
        this.msg.productSpecs.forEach((item) => {
          if (item.id === specId){
            specName = item.specName
          }
        })
         
        this.addCart(id, price, name, img, specId, specName,this.num)
      },
       addCart (id, price, name, img, specId, specName,num) {
         this.ADD_CART({
            productId: id,
            settlementPrice: price,
            name: name,
            defaultImage: img,
            num: num,
            specId: specId,
            specName:specName
          })
          // 加入购物车动画
          var dom = event.target
          // 获取点击的坐标
          let elLeft = dom.getBoundingClientRect().left + (dom.offsetWidth / 2)
          let elTop = dom.getBoundingClientRect().top + (dom.offsetHeight / 2)
          let imgs= "http://localhost:8888/static/images/logo.png"
          // 需要触发
          this.ADD_ANIMATION({moveShow: true, elLeft: elLeft, elTop: elTop, img: imgs})
          if (!this.showCart) {
            this.SHOW_CART({showCart: true})
          }
      },


      handleIconClick (ev) {
        console.log(123131)
          
      },
      handleSizeChange (val) {
        this.pageSize = val
        this._getSearch()
        this.loading = true
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this._getSearch()
        this.loading = true
      },
      async _getSearch () {       
        let MaxResultCount =  this.pageSize
        let SkipCount = (this.currentPage - 1) * this.pageSize
        let params = {
            skipCount: SkipCount,
            maxResultCount: MaxResultCount,
            categoryId:0,
            brandId:this.brandId,
            sortAsc:this.sortAsc,
            sorting:this.sorting,
            name: this.key,
            SearchKeyType:this.keyType
        }
        await this.loadGoodsList(params)
        this.loading = false
        this.searching = false
       
      }, 
      toDetail(id)
      {
        window.open('//' + window.location.host + '/#/goodsDetails?productId=' + id)
      },
      sortFun(val)
      {
         this.loading=true;
         this.currentPage = 1
         switch(val)
         {
            case 1:
              this.sortType = 1;
              this.sorting = '';
              this.sortAsc = false;
              break;
            case 2://价格升序
              this.sortType = 2;
              this.sorting = 'price';
              this.sortAsc = true;
              break;
            case 3://价格降序
              this.sortType = 3;
              this.sorting = 'price';
              this.sortAsc = false;
              break;
            case 4://销售降序
              this.billboardTitle ='热卖'
              this.sortType = 4;
              this.sorting = 'sales';
              this.sortAsc = false;
              break;
            case 5://新品降序
            this.billboardTitle ='新品'
              this.sortType = 5;
              this.sorting = 'new';
              this.sortAsc = false;
              break;
         }
         this._getSearch();
      },         
      brandMenu(index)
      {
        if (this.brandMenuIndex === index) {
          return;
        }
        this.brandMenuIndex = index;
        this.loading=true;
        this.brandId=index;
        this.currentPage=1;
        this._getSearch();
      },
      setBrandShow(val)
      {
        this.isShowMoreBrand=val;
      },
      _getBrands() {
        var _this=this;
      api.get('api/services/app/CommonLookup/GetBrands').then(res => {
        _this.brandList = res.data.result.items
        _this.showBrandList=[];
          for(var i=0;i<_this.brandList.length&&i<9;i++)
          {
            _this.showBrandList.push(_this.brandList[i]);
          }
        })
      },
      ...mapMutations(['ADD_CART', 'ADD_ANIMATION', 'SHOW_CART']),
      ...mapActions([
       'loadGoodsList',
      ])
    },
    created () {
      let id = this.$route.query.productId
    },
    computed: {
      ...mapGetters([
        'goods',
        'goodsTotal',
        'noResult'
      ])
    },
    mounted () {
      this.key = this.$route.query.key
      this.keyType = this.keyType || 0
      this.sortType = this.$route.query.sort || 1;      
      this.sortType = parseInt(this.sortType);
      this.sortFun(this.sortType);
      this._getBrands()
    },
    components: {
      YButton,    
      YShelf,
      SelectSpec
    }
  }
</script>



// WEBPACK FOOTER //
// billboard.vue?0742e719